export enum IdType {
  tckn,
  passport,
}
